export const TYPES = {
  FIREBASE_AUTH_STATUS: "user_auth/FIREBASE_AUTH_STATUS",
  FIREBASE_AUTH_UID: "user_auth/FIREBASE_AUTH_UID",
  FIREBASE_AUTH_EMAIL: "user_auth/FIREBASE_AUTH_EMAIL",
  FIREBASE_AUTH_DISPLAYNAME: "user_auth/FIREBASE_AUTH_DISPLAYNAME",
  FIREBASE_AUTH_PHOTOURL: "user_auth/FIREBASE_AUTH_PHOTOURL",
  FIREBASE_AUTH_PERMISSIONS: "user_auth/FIREBASE_AUTH_PERMISSIONS",
  //
  FIREBASE_AUTH_REGISTER_SUCCESS: "user_auth/FIREBASE_AUTH_REGISTER_SUCCESS",
  FIREBASE_AUTH_REGISTER_STEP: "user_auth/FIREBASE_AUTH_REGISTER_STEP",
  FIREBASE_AUTH_REGISTER_LASTMAIL: "user_auth/FIREBASE_AUTH_REGISTER_LASTMAIL",
};
